export * from "@smithy/protocol-http";
